import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Switch } from '../../components/ui/switch';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ModulesTab = ({ institutionId }) => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await axios.get(`${API}/core/institutions/${institutionId}/modules`); setModules(data); }
      catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, [institutionId]);

  const toggleModule = async (modKey, currentEnabled) => {
    try {
      await axios.put(`${API}/core/institutions/${institutionId}/modules/${modKey}`, !currentEnabled,
        { headers: { 'Content-Type': 'application/json' } });
      setModules(modules.map(m => m.module_key === modKey ? { ...m, is_enabled: !currentEnabled } : m));
      toast.success(`Module ${!currentEnabled ? 'active' : 'desactive'}`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
  };

  if (loading) return <div className="flex items-center justify-center p-12"><div className="w-8 h-8 border-3 border-blue-600 border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div data-testid="modules-tab">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {modules.map(m => (
          <Card key={m.module_key} className={`transition-all ${m.is_enabled ? '' : 'opacity-50'}`} data-testid={`module-${m.module_key}`}>
            <CardContent className="p-4 flex items-center justify-between">
              <div>
                <p className="font-medium text-sm">{m.name_fr || m.module_key}</p>
                <div className="flex gap-1.5 mt-1">
                  {m.is_core && <Badge className="text-[10px] bg-blue-100 text-blue-700">Core</Badge>}
                  <Badge variant={m.is_enabled ? "default" : "secondary"} className="text-[10px]">{m.is_enabled ? 'Actif' : 'Inactif'}</Badge>
                </div>
              </div>
              <Switch checked={m.is_enabled} onCheckedChange={() => toggleModule(m.module_key, m.is_enabled)} disabled={m.is_core} />
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-xs text-gray-400 mt-3 text-center">{modules.filter(m => m.is_enabled).length} module(s) actif(s) sur {modules.length}</p>
    </div>
  );
};
